export default __webpack_public_path__ + "static/media/ourMission.b6b79da4.svg";